import $ from "jquery";

class Dialogs {

    constructor() {
        this.handleDialogs();
    }

    handleDialogs() {
        $(document).ready(() => {
            $('.show-modal').click((event) => {
                event.preventDefault();

                const modal = event.currentTarget.getAttribute("href");
                const title = event.currentTarget.getAttribute('data-dialog-title');
                const hiddenValue = event.currentTarget.getAttribute('data-hidden-value');

                if (modal) {
                    if (title) {
                        $(modal).find('.dialog__box-header').text(title);
                    }

                    if (hiddenValue) {
                        $(modal).find('#hidden').val(hiddenValue);
                    }

                    $(modal).addClass("dialog--show");
                }
            });

            $('.dialog__bg:not(.force-stay), .dialog__box-close, .dialog__box-footer-close').click(() => {
                $('.dialog').removeClass("dialog--show");
            })
        });
    }

}

export default new Dialogs();
